(() => {
  const configElement = document.querySelector('[data-arcticmed-link-rewrites]');
  if (!configElement) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  if (!config.targetUrl) return;

  const targetUrl = new URL(config.targetUrl, window.location.origin);
  const rootPath = (config.rootUrl || window.Shopify?.routes?.root || '/').replace(/\/$/, '');
  const internalHosts = new Set([
    window.location.hostname,
    'arcticmed.com',
    'www.arcticmed.com',
    'arcticmed.myshopify.com',
  ]);
  const retiredPaths = new Set([
    '/products/arcticmed-omega-3-premium-lemon',
    '/products/6-pack-omega-3-premium',
    '/products/omega-3-premium-uk',
    '/en-ie/products/omega-3-premium',
    '/en-ie/en-uk/products/omega-3-premium-uk',
    '/en-uk/en-uk/products/omega-3-premium-uk',
  ]);

  function rewriteAnchor(anchor) {
    const href = anchor.getAttribute('href');
    if (!href || href.startsWith('#')) return;

    let currentUrl;
    try {
      currentUrl = new URL(href, window.location.href);
    } catch (error) {
      return;
    }

    if (!/^https?:$/.test(currentUrl.protocol) || !internalHosts.has(currentUrl.hostname)) return;

    if (retiredPaths.has(currentUrl.pathname)) {
      currentUrl.pathname = targetUrl.pathname;
    } else if (/^\/(products|pages)\//.test(currentUrl.pathname)) {
      currentUrl.pathname = currentUrl.pathname === '/products/omega-3-premium'
        ? targetUrl.pathname
        : `${rootPath}${currentUrl.pathname}`;
    } else {
      return;
    }

    const rewritten = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;
    if (href !== rewritten) anchor.setAttribute('href', rewritten);
  }

  function rewriteLinks(root) {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;

    if (root.nodeType === Node.ELEMENT_NODE && root.matches('a[href]')) {
      rewriteAnchor(root);
    }

    root.querySelectorAll('a[href]').forEach(rewriteAnchor);
  }

  rewriteLinks(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        rewriteAnchor(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(rewriteLinks);
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href'],
  });
})();
